<ng-container *ngIf="trackPageUrl">
  <iframe class="iframe" [src]="trackPageUrl"></iframe>
</ng-container>
